import { Box } from "@chakra-ui/react";
import AccountSetupScreen from "../../components/AccountSetupScreen/AccountSetupScreen";
import SetupBanner from "../../components/SetupBanner/SetupBanner";
import { useAuth } from "../../../../shared/providers/AuthProvider/AuthProvider";

const AccountSetupPage = () => {
    const { user } = useAuth();

    return (
        <Box w="100%" maxW={"85rem"} py={'80px'} px={4}>
            {!user?.isAccountConfigured && <SetupBanner />}
            <AccountSetupScreen />
        </Box>
    );
};

export default AccountSetupPage;
